import { VetClinicMarker } from "pages/veterinarkartan";
import styles from "./ClinicListItem.module.css";
import { FlexCol, FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";
import Colors from "ui-kit/colors";
import { Icon } from "ui-kit";
import classNames from "classnames";
import { formatCurrency } from "utils/utils";

const Separator = ({ className }: { className?: string }) => (
  <div className={classNames(styles.separator, className)} />
);

export const ClinicListItem = ({
  marker,
  onPress,
  selected,
}: {
  marker: VetClinicMarker;
  onPress: (marker: VetClinicMarker) => void;
  className?: string;
  selected?: boolean;
}) => {
  return (
    <li
      key={`${marker.id}`}
      className={classNames(styles.clinicListItem, {
        [styles.selected]: selected,
      })}
      onClick={() => onPress(marker)}
    >
      <FlexRow>
        <FlexCol style={{ gap: 8 }}>
          <FlexRow>
            <Typography
              variant="body1"
              style={{ fontFamily: "var(--font-eina-semi-bold)" }}
            >
              {marker.name}
            </Typography>
          </FlexRow>

          {marker.median_amount && (
            <FlexRow
              style={{ gap: 8 }}
              alignItems="center"
              className={styles.ratingContainer}
            >
              <FlexRow
                alignItems="center"
                style={{ gap: 8, maxWidth: "fit-content" }}
              >
                <Typography variant="body3" color="grey500">
                  {`Snittkostnad skada: ${formatCurrency(marker.median_amount, {
                    maximumFractionDigits: 0,
                  })}`}
                </Typography>
              </FlexRow>
            </FlexRow>
          )}

          <FlexRow style={{ gap: 8 }}>
            <FlexRow style={{ maxWidth: "fit-content" }}>
              <Typography
                variant="body3"
                style={{ fontFamily: "var(--font-eina-semi-bold)" }}
                color={marker.openNow ? "forrest600" : "grey300"}
              >
                {marker.openNow ? "Öppet nu" : "Stängt"}
              </Typography>
            </FlexRow>
            {marker.billables?.direktreglering && (
              <FlexRow alignItems="center" className={styles.directSettlement}>
                <Separator />
                <Icon name="checkmark" color={Colors.grey400} size="M" />
                <Typography variant="body3" color="grey500">
                  Direktreglering
                </Typography>
              </FlexRow>
            )}
          </FlexRow>
        </FlexCol>
        <FlexRow
          justifyContent="flex-end"
          alignItems="center"
          className={styles.chevronRight}
        >
          <Icon name="chevron-right" />
        </FlexRow>
      </FlexRow>
    </li>
  );
};
